module App.Interfaces {
    export interface IValidationService {
        goToNextStepValidated();
        clearLoadingTimer();
    }
}